import { memberStorage, stateParamsForSubscription } from 'utils';
import { fetchProducts, selectProduct } from 'logic/signup';
import { setNavType, setTheme } from 'logic/theme';
import { initFavourites } from 'logic/favourite';

import {
  fetchMember,
  selectMember,
  selectSubscription,
  selectSubscriptionWithFallback,
} from 'logic/member';

export const authCheck = ($ngRedux, $state, $transitions) => {
  'ngInject';

  const authenticatedPage = ({ name, authenticate }) => {
    return authenticate;
  };

  const loginPage = ({ name }) => {
    return name === 'login';
  };

  const authenticatedPageRedirectTo = ({ name, authenticate }) => {
    return (
      authenticate && !/welcome|profileCreditCard|workoutPlayer/.test(name)
    );
  };

  // Redirect after login.
  $transitions.onBefore({ to: loginPage }, $transition$ => {
    const { memberId, redirectTo } = memberStorage.get();

    const unsubscribe = $ngRedux.subscribe(() => {
      const { member } = $ngRedux.getState();
      const subscription = selectSubscriptionWithFallback(member);
      const { voomeProductId } = subscription;

      // Only run once when the member has been set.
      if (voomeProductId) {
        unsubscribe();

        const { name, params } = stateParamsForSubscription(
          subscription,
          redirectTo
        );

        const stateMember = selectMember(member);

        // Store the memberId && voomeProductId.
        memberStorage.set({
          memberId: stateMember.id,
          voomeProductId,
        });

        // Load the favourite
        $ngRedux.dispatch(initFavourites(stateMember.id));

        // Redirect to the appropriate page.
        $state.transitionTo(name, params);
        return false;
      }
    });

    // Refetch member if memberId exists in local storage.
    if (memberId) {
      $ngRedux.dispatch(fetchMember(memberId));
      return false;
    }
  });

  // Logout & save the current location for unauthenticated users.
  $transitions.onBefore({ to: authenticatedPage }, $transition$ => {
    const { memberId } = memberStorage.get();

    if (!memberId) {
      memberStorage.setKey('redirectTo', {
        name: $transition$.targetState().name(),
        params: $transition$.targetState().params(),
      });

      $state.transitionTo('login');
      return false;
    }
  });

  // Refetch a member that has lost state.
  $transitions.onBefore({ to: authenticatedPage }, $transition$ => {
    const voomeProductId =
      $transition$.params().voomeProductId ||
      memberStorage.get().voomeProductId;

    const { member, signup } = $ngRedux.getState();

    // Refetch Products if undefined.
    if (!selectProduct(signup, voomeProductId)) {
      $ngRedux.dispatch(fetchProducts());
    }

    // Refetch Member if undefined.
    if (!selectSubscription(member, voomeProductId).id) {
      const { memberId } = memberStorage.get();

      const unsubscribe = $ngRedux.subscribe(() => {
        const { member } = $ngRedux.getState();

        if (selectSubscription(member, voomeProductId).id) {
          unsubscribe();
          $ngRedux.dispatch(initFavourites(memberId));
          $state.transitionTo($transition$.to().name, $transition$.params());
        }
      });

      // Load the member
      $ngRedux.dispatch(fetchMember(memberId));

      $transition$.abort();
    }
  });

  // Set the navigation.
  $transitions.onBefore({ to: authenticatedPage }, $transition$ => {
    const voomeProductId =
      $transition$.params().voomeProductId ||
      memberStorage.get().voomeProductId;

    const { theme, member } = $ngRedux.getState();
    const { isWeekly, slug, status } = selectSubscription(
      member,
      voomeProductId
    );
    const { name } = $transition$.to();

    if (slug && theme.slug.indexOf(slug) < 0) {
      $ngRedux.dispatch(setNavType(name === 'welcome' ? 'plain' : 'main'));
      $ngRedux.dispatch(setTheme(isWeekly, slug, status));
    }
  });

  // Save the route. $state returns the correct params for abstract routes.
  $transitions.onSuccess({ to: authenticatedPageRedirectTo }, $transition$ => {
    if (memberStorage.get().memberId) {
      memberStorage.setKey('redirectTo', {
        name: $state.current.name,
        params: $state.params,
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/utils/authCheck.js